import {
    RiGiftLine,
    RiNotification3Line,
} from "@remixicon/react";
import React, { useMemo, useState } from "react";
import { Loading } from "../../components";

import { Article, ArticleTag } from "../../__generated__/api";
import { ModalWithNavigation } from "../../components/confirm/ModalWithNavigation";

import Settings, { UpdatesSettings } from "./Settings";
import UpdateDisplay from "./UpdateDisplay";
import { LoggingHandler } from "../logging/LoggingContext";

export default function UpdatesModal({
    isLoading,
    tags,
    settings,
    setSettings,
    lastRead,
    articles,
    onHide,
}: {
    isLoading: boolean;
    tags: ArticleTag[];
    settings: UpdatesSettings;
    lastRead: number;
    setSettings: (settings: UpdatesSettings) => void;
    articles: Article[];
    onHide: () => void;
}) {
    const [selectedCategory, setSelectedCategory] = useState<ArticleTag>();

    const checkedCategories = useMemo(() => new Set(settings.selectedTags) ?? [], [settings.selectedTags]);
    const categories = useMemo(() => ([
        {
            id: "latest",
            title: "Latest",
        },
        ...(tags?.map(category => ({
            id: category.id,
            title: category.title,
            iconUrl: category.iconUrl as string,
            value: category,
            postfixIcon: checkedCategories.has(category.id) ? <RiNotification3Line /> : undefined,
        })) ?? []),
    ]), [checkedCategories, tags]);

    return (
        <ModalWithNavigation
            title="Updates"
            categoryIcon={<RiGiftLine />}
            isDisplayed
            onHide={onHide}
            onSelectedCategory={category => setSelectedCategory(category as ArticleTag)}
            selectedCategoryId="latest"
            metricsPathPrefix={[LoggingHandler.Metrics.UPDATES, "categories"]}
            navigationFooter={(
                <Settings
                    tags={tags as ArticleTag[]}
                    settings={settings}
                    metricPathPrefix={[LoggingHandler.Metrics.UPDATES, "settings"]}
                    onSave={updates => setSettings({
                        ...settings,
                        ...updates,
                    })}
                />
            )}
            categories={categories}
        >
            {isLoading ? <Loading /> : (
                <UpdateDisplay
                    selectedCategory={selectedCategory}
                    articles={articles}
                    lastRead={lastRead}
                />
            )}
        </ModalWithNavigation>
    );
}
